import React, { useState, useEffect } from 'react';
import styles from 'components/checkbox/index.module.scss';

const Checkbox = ({ id, name, isChecked, onCheckChanged, style }) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const onChangeHandler = event => {
    if (onCheckChanged) onCheckChanged(event.target.checked);
  };

  return (
    <div className={styles.checkbox} style={style}>
      <label htmlFor={id}>
        <input id={id} value={id} checked={checked} type="checkbox" onChange={onChangeHandler} />
        <span className={styles.text}>{name}</span>
      </label>
    </div>
  );
};

export default Checkbox;
